export const selectTeams = (state) => state.team.teams;
export const selectTeamsStatus = (state) => state.team.teamsStatus;

/* Members and flow are stored per team, so the selectors are factories.
   Falling back to an empty array (never undefined) keeps callers from having
   to guard before mapping to dropdown options.

   The fallback is one shared frozen array rather than a fresh `[]`. useSelector
   compares by reference, so returning a new empty array on each call would
   make every store notification look like a change and re-render the dialog
   for as long as the team's members had not loaded. */
const EMPTY = Object.freeze([]);

export const selectMembersOfTeam = (teamCode) => (state) =>
  state.team.membersByTeam[teamCode ?? "all"] || EMPTY;

export const selectFlowFromTeam = (teamCode) => (state) =>
  state.team.flowByTeam[teamCode ?? "all"] || EMPTY;

export const selectMembersStatus = (state) => state.team.membersStatus;
export const selectFlowStatus = (state) => state.team.flowStatus;

export const selectTaskTimeline = (state) => state.team.timeline;
export const selectTaskTimelineStatus = (state) => state.team.timelineStatus;

export const selectMoveStatus = (state) => state.team.moveStatus;

export const selectTeamWise = (state) => state.team.teamWise;
export const selectTeamWiseStatus = (state) => state.team.teamWiseStatus;
